import ProgramCopyrightSelector from './ProgramCopyrightSelector';

export default ProgramCopyrightSelector;
